export const gcpImagePaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/images`,
  detail: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/images/${encodeURIComponent(name)}`,
  create: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/images`,
  update: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/images/${encodeURIComponent(name)}`,
  remove: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/images/${encodeURIComponent(name)}`,
};
